import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/clone1.png'
import _imports_1 from '../assets/clone.png'


const _withScopeId = n => (_pushScopeId("data-v-ca486cf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
}

import { Icon } from "vant";




export default /*#__PURE__*/_defineComponent({
  __name: 'TopNav',
  props: {
    back: {},
    text: {},
    color: {},
    clone: {},
    add: {}
  },
  setup(__props: any) {

const props = __props;

function goBack() {
  // window.history.back();
  console.log(props.add);
  
  if(props.add != 1){
    AlipayJSBridge.call('gotoHomeYouBank',{
    homePageIndex:'4'
  })
  }else{
    window.history.back();
  }
}
function goBack1(){
  AlipayJSBridge.call('gotoHomeYouBank',{
    homePageIndex:'4'
  })
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "nav",
      style: _normalizeStyle({ color: _ctx.color })
    }, [
      (_ctx.back)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fanhui",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
          }, [
            _createVNode(_component_van_icon, { name: "arrow-left" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.text), 1),
      _createElementVNode("div", {
        class: "right",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (goBack1()))
      }, [
        (_ctx.clone == 0)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4))
      ])
    ], 4)
  ]))
}
}

})